"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheetManagement = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var ApprovalSheetManagementContext_1 = require("../../context/ApprovalSheetManagementContext");
var ApprovalSheetManagementHeader_1 = require("./components/ApprovalSheetManagementHeader");
var ApprovalSheetManagementFooter_1 = require("./components/ApprovalSheetManagementFooter");
var styles_1 = require("@material-ui/core/styles");
var useFlag_1 = require("../../hooks/useFlag");
var ApprovalSheetCreateOrEditGroupDialog_1 = require("./components/ApprovalSheetCreateOrEditGroupDialog");
var ApprovalSheetContext_1 = require("../../context/ApprovalSheetContext");
var ApprovalSheetGroups_1 = require("./components/ApprovalSheetGroups");
var EmptyGroupsMessage_1 = require("./components/EmptyGroupsMessage");
var useApprovalSheetManagementStyles = styles_1.makeStyles(function (theme) {
    var _a = theme.variables.palette.approval, panelDetailsHeight = _a.panelDetailsHeight, backgroundColorBase = _a.backgroundColorBase, borderBase = _a.borderBase, borderRadiusBase = _a.borderRadiusBase, panelFooterHeight = _a.panelFooterHeight;
    return {
        detailsContainer: {
            height: panelDetailsHeight,
            backgroundColor: backgroundColorBase,
            border: borderBase,
            borderRadius: "0px 0px " + borderRadiusBase + " " + borderRadiusBase,
        },
        contentContainer: {
            height: "calc(100% - " + panelFooterHeight + ")",
        },
    };
});
exports.ApprovalSheetManagement = function () {
    var sheet = react_1.useContext(ApprovalSheetContext_1.ApprovalSheetContext).sheet;
    var flowTemplateTitle = sheet.flowTemplateTitle, groups = sheet.groups;
    var _a = react_1.useState(groups || []), groupsUpdated = _a[0], setGroupsUpdated = _a[1];
    var _b = useFlag_1.useFlag(), isEditSheet = _b[0], setIsEditSheetTrue = _b[1], setIsEditSheetFalse = _b[2];
    var _c = useFlag_1.useFlag(), isAddGroupModalOpen = _c[0], setIsAddGroupModalOpenTrue = _c[1], setIsAddGroupModalOpenFalse = _c[2];
    var _d = react_1.useState(null), editGroup = _d[0], setEditGroup = _d[1];
    var classes = useApprovalSheetManagementStyles();
    react_1.useEffect(function () {
        setGroupsUpdated(groups);
    }, [groups]);
    return (react_1.default.createElement(ApprovalSheetManagementContext_1.ApprovalSheetManagementContext.Provider, { value: {
            isEditSheet: isEditSheet,
            setIsEditSheetTrue: setIsEditSheetTrue,
            setIsEditSheetFalse: setIsEditSheetFalse,
            isAddGroupModalOpen: isAddGroupModalOpen,
            setIsAddGroupModalOpenTrue: setIsAddGroupModalOpenTrue,
            setIsAddGroupModalOpenFalse: setIsAddGroupModalOpenFalse,
            groupsUpdated: groupsUpdated,
            setGroupsUpdated: setGroupsUpdated,
            editGroup: editGroup,
            setEditGroup: setEditGroup,
        } },
        react_1.default.createElement(ApprovalSheetManagementHeader_1.ApprovalSheetManagementHeader, { templateName: flowTemplateTitle }),
        react_1.default.createElement(core_1.Grid, { container: true, direction: "column", wrap: "nowrap", className: classes.detailsContainer },
            react_1.default.createElement(core_1.Grid, { item: true, className: classes.contentContainer }, groupsUpdated.length > 0 ? react_1.default.createElement(ApprovalSheetGroups_1.ApprovalSheetGroups, { groups: groupsUpdated }) : react_1.default.createElement(EmptyGroupsMessage_1.EmptyGroupsMessage, null)),
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(ApprovalSheetManagementFooter_1.ApprovalSheetManagementFooter, null))),
        react_1.default.createElement(ApprovalSheetCreateOrEditGroupDialog_1.ApprovalSheetCreateOrEditGroupDialog, null)));
};
